import React, { useState, useEffect } from "react";
import Supplychain from "../../contracts/SupplyChain.json";
import Web3 from "web3";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./adminsupplychain.css";
import { Link } from "react-router-dom";

function AdminSupplyChain() {
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);

  let id = 0;
  async function see() {
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();
    const networkId = await web3.eth.net.getId();
    const deployedNetwork = Supplychain.networks[networkId];
    const instance = new web3.eth.Contract(
      Supplychain.abi,
      deployedNetwork && deployedNetwork.address
    );
    let res = await instance.methods.fetchMedicineBufferTwo(id).call();
    let temp = await instance.methods.fetchMedicine(id).call();
    setData1(res);
    setData2(temp);
    console.log(res.medicineState);
    for (let i = 0; i <= res.medicineState; i++) {
      document.getElementById("" + i).style.background = "green";
    }
  }

  useEffect(() => {
    see();
  }, []);

  return (
    <div className="container container-fluid login-conatiner">
      <div style={{ padding: "5px" }}>
        <div className="d-flex flex-row btn btn-dark btn-lg btn-block">
          <Link to="/admin/home">
            <Button variant="secondary">Home</Button>
          </Link>{" "}
          <Link
            style={{ color: "white", marginLeft: "990px" }}
            to="/admin/resources"
          >
            <Button variant="secondary">View the Supply Chain</Button>
          </Link>{" "}
        </div>
      </div>
      <h1
        style={{
          textAlign: "center",
          marginTop: "3%",
        }}
      >
        SUPPLY CHAIN STATUS
      </h1>
      <div
        style={{
          alignItems: "center",
          marginLeft: "45%",
        }}
      >
        <Link to={`/viewsupply`} state={{ data1: data1, data2: data2 }}>
          <Button className="btn btn-dark btn-lg btn-block">View More</Button>
        </Link>
      </div>
      <div className="circleBase main-left" id="0">
        <p className="circle_text_container">START </p>
      </div>
      <div className="circleBase main-other" id="1">
        <p className="circle_text_container_side">PACK</p>
      </div>
      <div className="circleBase main-other" id="2">
        <p className="circle_text_container_side">SELL</p>
      </div>
      <div className="circleBase main-other" id="3">
        <p className="circle_text_container_side">BUY</p>
      </div>
      <div className="circleBase main-other" id="4">
        <p className="circle_text_container_side">SHIP</p>
      </div>
      <div className="circleBase main-other" id="5">
        <p className="circle_text_container_temp">RECEIVE</p>
      </div>
      {/* <div className="circleBase main-other" id="6">
				<p className="circle_text_container_temp">PURCHASE</p>
			</div> */}
    </div>
  );
}

export default AdminSupplyChain;
